<nz-card [nzBordered]="false" [nzTitle]="cardTitle">
  <ng-template #cardTitle>
    <div class="header">
      <laveo-card-header
        title="Rapport : Véhicules"
        [description]="description"
        [backButtonEnabled]="true"
        (backButtonClick)="back()"
        [isLoading]="isLoading"
        buttonTitle="Export excel"
        buttonIcon="download"
        (buttonClick)="export()"
      ></laveo-card-header>
    </div>
  </ng-template>
  <div nz-row [nzGutter]="[16, 16]">
    <form nz-form [formGroup]="form" nzLayout="vertical">
      <div nz-row nzGutter="8" class="mt-8" *ngIf="userCanChooseSelectedRole">
        <div nz-col [nzSm]="24" [nzMd]="12" [nzXl]="8">
          <nz-form-item>
            <nz-form-label nzFor="group">Grouper par</nz-form-label>
            <nz-form-control>
              <nz-select
                id="role"
                nzSize="large"
                nzPlaceHolder="Grouper par"
                [nzShowArrow]="true"
                [nzShowSearch]="true"
                formControlName="role"
                [style.minWidth]="'200px'">
                <nz-option
                  [nzLabel]="UserRoleType.customer | roleName"
                  [nzValue]="UserRoleType.customer">
                </nz-option>
                <nz-option
                  [nzLabel]="UserRoleType.customerSite | roleName"
                  [nzValue]="UserRoleType.customerSite">
                </nz-option>
                <nz-option
                  [nzLabel]="UserRoleType.structure | roleName"
                  [nzValue]="UserRoleType.structure">
                </nz-option>
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </form>
    <nz-table
      nzBordered
      nzShowSizeChanger
      [nzScroll]="{ x: '2500px' }"
      [nzData]="data ? data.data : []"
      [nzFrontPagination]="false"
      [nzLoading]="isLoading"
      [nzTotal]="data ? data.metadata.totalResults : 0"
      [nzPageSize]="limit"
      [nzPageIndex]="currentPage ? currentPage : 1"
      [nzNoResult]="emptyTemplate"
      (nzQueryParams)="setPage($event)"
      *ngIf="!error; else errorTemplate">
      <thead>
        <tr>
          <th nzLeft nzColumnKey="customer" *ngIf="selectedRole === UserRoleType.customerSite">Client</th>
          <th nzLeft [nzColumnKey]="selectedRole">{{ selectedRole | roleName }}</th>
          <th nzColumnKey="total">Véhicules (total)</th>
          <th nzColumnKey="active">Véhicules (actifs)</th>
          <th *ngFor="let vehicleCategory of vehicleCategories" [nzColumnKey]="'vehicleCategory-' + vehicleCategory">Catégorie {{ vehicleCategory | vehicleCategoryName}}</th>
          <th>{{ vehicleFrequency.on_demand| vehicleFrequencyName}}</th>
          <th *ngFor="let vehicleAttribution of vehicleAttributions" [nzColumnKey]="'vehicleAttribution-' + vehicleAttribution">{{ vehicleAttribution | vehicleAttributionName}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of data?.data">
          <td nzLeft *ngIf="selectedRole === UserRoleType.customerSite">
            <span>{{ row?.customer?.name}}</span>
          </td>
          <td nzLeft>
            <span *ngIf="selectedRole === UserRoleType.customer">{{ row?.customer?.name}}</span>
            <span *ngIf="selectedRole === UserRoleType.customerSite">{{ row?.customerSite?.name}}</span>
            <span *ngIf="selectedRole === UserRoleType.structure">{{ row?.structure?.name}}</span>
          </td>
          <td>
            <a [routerLink]="['/', 'vehicles']" [queryParams]="{ s: row.actor.name }">
              {{ row.nb }}
            </a>
          </td>
          <td>
            <a [routerLink]="['/', 'vehicles']" [queryParams]="{ s: row.actor.name, active: true }">
              {{ row.nbActive }}
            </a>
          </td>
          <td>{{ row.nbCatA }}</td>
          <td>{{ row.nbCatB }}</td>
          <td>{{ row.nbCatC }}</td>
          <td>{{ row.nbCatD }}</td>
          <td>{{ row.nbCatVU }}</td>
          <td>{{ row.nbCatPorteur }}</td>
          <td>{{ row.nbCatPL }}</td>
          <td>{{ row.nbCatHG }}</td>
          <td>{{ row.nbCatMoto }}</td>
          <td>{{ row.nbOnDemand }}</td>
          <td>{{ row.nbAffected }}</td>
          <td>{{ row.nbMutualized }}</td>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #errorTemplate>
      <nz-result
        nzTitle="Erreur de chargement"
        nzStatus="error"
        nzSubTitle="Une erreur est survenue lors du chargement du reporting">
        <div nz-result-extra>
          <button nz-button nzType="primary" (click)="loadData()">
            Réessayer
            <i nz-icon nzType="reload"></i>
          </button>
        </div>
      </nz-result>
    </ng-template>
    <ng-template #emptyTemplate>
      <nz-empty
        nzNotFoundImage="simple"
        nzNotFoundContent="Il n'y a encore aucune données pour le moment.">
      </nz-empty>
    </ng-template>
  </div>
</nz-card>

<ng-template #exportForm let-params>
  <form nz-form [formGroup]="params.exportForm">
    <h5 [style.marginTop]="0" [style.marginBottom]="'16px'">Informations</h5>
    <nz-form-item>
      <nz-form-label [nzSm]="10" nzFor="role">Grouper par</nz-form-label>
      <nz-form-control [nzSm]="14">
        <nz-select formControlName="role">
          <nz-option [nzLabel]="UserRoleType.customer | roleName" [nzValue]="UserRoleType.customer"></nz-option>
          <nz-option [nzLabel]="UserRoleType.customerSite | roleName" [nzValue]="UserRoleType.customerSite"></nz-option>
          <nz-option [nzLabel]="UserRoleType.structure | roleName" [nzValue]="UserRoleType.structure"></nz-option>
        </nz-select>
      </nz-form-control>
    </nz-form-item>
    <h5 [style.marginTop]="0" [style.marginBottom]="'16px'">Options</h5>
    <p [style.marginBottom]="0">Nombre de résultats :</p>
    <nz-radio-group formControlName="page">
      <label nz-radio-button nzValue="current" class="radio-line">Page actuelle</label>
      <label nz-radio-button nzValue="all" class="radio-line">Tous les résultats</label>
    </nz-radio-group>
    <nz-form-item>
      <nz-form-label [nzSm]="24" nzFor="filename" [style.textAlign]="'left'">Nom du fichier</nz-form-label>
      <nz-form-control>
        <nz-input-group nzAddOnAfter=".xlsx">
          <input nz-input id="filename" name="filename" placeholder="export" formControlName="filename">
        </nz-input-group>
      </nz-form-control>
    </nz-form-item>
  </form>
</ng-template>
